import {
    Directive,
    ComponentRef,
    ViewContainerRef,
    Input,
    ComponentFactoryResolver,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { CoachMarkComponent } from './CoachMark.component';

@Directive({
    selector: '[coachMark]',
    standalone: false
})
export class CoachMarkDirective implements OnChanges {
    @Input()
    coachMarkContent: string | CoachMarkComponent;
    @Input()
    coachMarkShow: boolean;
    @Input()
    coachMarkPlacement: 'top' | 'bottom' | 'left' | 'right' = 'bottom';
    @Input()
    coachMarkArrowDirection: 'left' | 'right' = 'right';
    @Input()
    coachMarkDelay = 0;

    private coachMark: ComponentRef<CoachMarkComponent>;
    private visible: boolean;
    private internalTimer: number;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private resolver: ComponentFactoryResolver
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.coachMarkShow) {
            if (changes.coachMarkShow.currentValue === true) {
                this.show();
            } else {
                this.hide();
            }
        }
    }

    show(): void {
        if (this.visible) {
            return;
        }

        this.visible = true;

        this.internalTimer = window.setTimeout(() => {
            if (!this.coachMarkContent) {
                throw new Error('this.content is undefined/null');
            }

            if (typeof this.coachMarkContent === 'string') {
                const factory =
                    this.resolver.resolveComponentFactory(CoachMarkComponent);

                this.coachMark = this.viewContainerRef.createComponent(factory);
                this.coachMark.instance.hostElement =
                    this.viewContainerRef.element.nativeElement;
                this.coachMark.instance.content = this.coachMarkContent;
                this.coachMark.instance.placement = this.coachMarkPlacement;
                this.coachMark.instance.arrowDirection =
                    this.coachMarkArrowDirection;
            } else {
                const coachMark = this.coachMarkContent;
                coachMark.hostElement =
                    this.viewContainerRef.element.nativeElement;
                coachMark.placement = this.coachMarkPlacement;
                coachMark.arrowDirection = this.coachMarkArrowDirection;
                coachMark.show();
            }
        }, this.coachMarkDelay);
    }

    hide(): void {
        if (!this.visible) {
            return;
        }

        this.visible = false;

        clearTimeout(this.internalTimer);

        if (this.coachMark) {
            this.coachMark.destroy();
        }

        if (this.coachMarkContent instanceof CoachMarkComponent) {
            this.coachMarkContent.hide();
        }
    }
}
